module.exports = __webpack_public_path__ + "img/jt.274c0fe2.jpg";